import React from 'react';
import PropTypes from 'prop-types';
import {url} from 'src/shared/utils/url';

export const DeflectionMovingBox = ({className}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" className={className} role="img" aria-hidden="true">
    <defs>
      <linearGradient id="deflection-moving-box-gradient" x1="15.1" y1="9.6" x2="39.55" y2="51.94" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#d4f2ff" />
        <stop offset="1" stopColor="#d9f3ff" stopOpacity="0" />
      </linearGradient>
    </defs>
    <path fill={url('#deflection-moving-box-gradient')} d="M49.75,19.11a17.24,17.24,0,0,0-3-1.18,9.92,9.92,0,0,0-2-.39c-10.69-2.22-15.09-7-15.09-7A9.68,9.68,0,0,0,17,8.49a9.84,9.84,0,0,0-3.76,12.25c1.88,3.92-1.88,5.49-3.76,6-.32.07-.65.13-.91.2H8.55A10.77,10.77,0,0,0,1.41,40.18a10.66,10.66,0,0,0,13,7.47h.07a11.92,11.92,0,0,0,1.94-.78c7-2.48,14.45-1.63,19.37-.59A15.12,15.12,0,0,0,56,39.63,15.37,15.37,0,0,0,49.75,19.11Z" />
    <ellipse fill="#e8eef0" cx="31.25" cy="50.16" rx="23.88" ry="1.91" />
    <polygon fill="#af7400" points="45.35 20.31 57.72 14.04 52.13 23.92 39.17 30.19 45.35 20.31" />
    <path fill="#dd8400" d="M50.88,50.72a1.26,1.26,0,0,0,1.26-1.25V23.92H24.57v26.8Z" />
    <path fill="#c27500" d="M30.15,23.92H24.57v26.8H45.7c-2.3-1.18-11.2-6.09-14.48-16.46A26.39,26.39,0,0,1,30.15,23.92Z" />
    <polygon fill="#885a00" points="3.26 22.21 15.63 15.94 24.61 23.92 12.24 30.19 3.26 22.21" />
    <path fill="#af7400" d="M24.6,23.92,12.24,30.19V48.85a1.88,1.88,0,0,0,1.88,1.87H24.6Z" />
    <path fill="#885a00" d="M33.87,46.12H27.11A.1.1,0,0,1,27,46a.11.11,0,0,1,.1-.1h6.76a.11.11,0,0,1,.1.1A.1.1,0,0,1,33.87,46.12Z" />
    <path fill="#885a00" d="M38.46,48.41H27.11a.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1H38.46a.11.11,0,0,1,.1.1A.1.1,0,0,1,38.46,48.41Z" />
  </svg>
);

DeflectionMovingBox.propTypes = {
  className: PropTypes.string,
};
